<template>
    <div class="wizard__wrap wizard__wrap--historical">
        <div class="row">
            <a href="" @click="onPrevPage">Previous</a>
        </div>
        <div class="wizard__block">
            <div class="row">
                <div class="logo logo--after">{{ agencyName }}</div>
            </div>
            <div class="wizard__block-title">Historical data</div>
            <div class="wizard__block-table">
                <table class="table">
                    <thead>
                        <tr>
                            <th class="center">Period</th>
                            <th>Brand</th>
                            <th>Service</th>
                            <th>Amount</th>
                            <th>Hard cost</th>
                            <th>Commission, %</th>
                            <th>Commission, $</th>
                            <th>Collected</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-if="data.length > 0"
                            v-for="(sli, index) in data"
                            :key="`historical_item_${index}`"
                        >
                            <td>{{ getPeriodDate(sli.period) }}</td>
                            <td>{{ sli.brand }}</td>
                            <td>{{ sli.service }}</td>
                            <td>${{ sli.amount }}</td>
                            <td>${{ sli.hard_cost }}</td>
                            <td>{{ sli.commission_percent }}%</td>
                            <td>${{ sli.commission_value }}</td>
                            <td>${{ sli.collected }}</td>
                        </tr>
                        <tr v-else>
                            <td colspan="8">No data</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="wizard__block-nav">
                <button @click="onPrevPage" class="btn btn--prev btn--white">
                    Previous
                </button>
            </div>
            <div class="loader" v-if="isLoading">
                <clip-loader
                    :loading="isLoading"
                    :color="'#ec4657'"
                    :size="'45px'"
                ></clip-loader>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import ClipLoader from "vue-spinner/src/ClipLoader";

import { SECTIONS } from "../consts";

export default {
    name: "Wizard_Hystorical_Data",
    props: ["onChangeSection"],
    components: {
        ClipLoader,
    },
    data() {
        return {
            data: [],
            isLoading: false,
        };
    },
    mounted() {
        this.getData();
    },
    computed: {
        agencyName() {
            return this.$store.getters.getAgencyName;
        },
    },
    methods: {
        getPeriodDate(date = null) {
            if (date) {
                return moment(date).format("MM/YYYY");
            }
            return "";
        },
        onPrevPage(e) {
            e.preventDefault();

            this.onChangeSection(
                SECTIONS.FINAL_DASHBOARD,
                SECTIONS.HYSTORICAL_DATA
            );
        },
        async getData() {
            try {
                this.isLoading = true;

                await axios
                    .get("/api/wizard/getHistoricalData")
                    .then((res) => {
                        const { data } = res;

                        this.data = data;
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            } catch (err) {
                console.error(err);
            }
        },
    },
};
</script>
